import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Weight icon — three horizontal weight bars. */
const WeightIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M16 6.16797C16.2761 6.16797 16.5 6.39183 16.5 6.66797C16.5 6.94411 16.2761 7.16797 16 7.16797H4C3.72386 7.16797 3.5 6.94411 3.5 6.66797C3.5 6.39183 3.72386 6.16797 4 6.16797H16Z" fill="currentColor" />
    <path d="M16 9.375C16.3452 9.375 16.625 9.65482 16.625 10C16.625 10.3452 16.3452 10.625 16 10.625H4C3.65482 10.625 3.375 10.3452 3.375 10C3.375 9.65482 3.65482 9.375 4 9.375H16Z" fill="currentColor" />
    <path d="M16 12.582C16.4142 12.582 16.75 12.9178 16.75 13.332C16.75 13.7462 16.4142 14.082 16 14.082H4C3.58579 14.082 3.25 13.7462 3.25 13.332C3.25 12.9178 3.58579 12.582 4 12.582H16Z" fill="currentColor" />
  </svg>
);

export default WeightIcon;
